import Axios from 'axios'
import i18n from '../../i18n'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8080'
const tcBaseUrl = config.apiDomain.ALI + '/ext/training/api/tc/' // training course
const pcBaseUrl = tcBaseUrl + 'pc/' // proposal class
const ipfBaseUrl = tcBaseUrl + 'ipf/' // past filled form
// const noClassCodeUrl = baseUrl + '//nojwt/allCurrentClassWithoutClassCode'
// const classCodeUrl = baseUrl + '//nojwt/getClassByClassCode'
// const insertFormUrl = baseUrl + '/ApplicationFormData/nojwt/insertNewform'
// const outlinePathUrl = baseUrl + '//nojwt/getOutlinePath'
const insertFormUrl = tcBaseUrl + 'afData/insertNewform?langCode='
const noClassCodeUrl = pcBaseUrl + 'findCurrentActiveCoursesWithAppliedForm'
const classCodeUrl = pcBaseUrl + 'findByClassCodeWithAppliedForm/'
const outlinePathUrl = pcBaseUrl + 'getOutlinePath/'
const subordinateIPFormReportUrl = ipfBaseUrl + 'getSubordinateIPFormReport' // Get the subordinate's internal propose forms (3 years)
const internalProposeFormUrl = ipfBaseUrl + 'getPersonalInternalProposeForm' // InternalProposeForm

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// Axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
// Axios.defaults.headers.get['Access-Control-Allow-Headers'] = 'Authorization,Origin, X-Requested-With, Content-Type, Accept'
// Axios.defaults.headers.get['Access-Control-Allow-Methods'] = 'GET,POST'
Axios.defaults.headers.timeout = 8000

export default {

  getAllCurrentCourse (cb) {
    Axios.get(noClassCodeUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getCourseByClassCode (classCode, cb) {
    Axios.get(classCodeUrl + classCode).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  getCourseOutlinePath (outlineDmsId, cb) {
    Axios.get(outlinePathUrl + outlineDmsId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getSubordinateIPFormReport (cb) {
    Axios.get(subordinateIPFormReportUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  submitForm (form, cb) {
    Axios.post(insertFormUrl + i18n.locale, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        cb(error.response)
      }
    )
  },

  getInternalProposeFormList (cb) {
    Axios.get(internalProposeFormUrl).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
      }
    )
  }

}
